import React,{useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { COOKIESPREFIX } from '../config';
//svg
import LoadingSvg from '../svgs/LoadingSvg'
//screens
import Nav from '../components/Nav'
import { useLayoutEffect } from 'react';
import { insertRedirectRecords } from '../services/service';
function App() {
  const navigate = useNavigate()
  const [videoLoaded, setVideoLoaded] = useState(true)
  const [isClick, setIsClick] = useState(true)
  const [isNavOpen, setIsNavOpen] = useState(false)
  const startVidRef = useRef()
  const startDivRef = useRef()
  const loopVideoRef = useRef()
  const timerRef = useRef()
  useEffect(() => {
    return() => {
      clearTimeout(timerRef.current)
    }
  },[])
  function VideoReady(){
    console.log('asdfadf')
    setVideoLoaded(true)
    startVidRef.current.play()
    setTimeout(() => setIsClick(true), 3000)
    timerRef.current = setTimeout(() => {
      if(startDivRef.current?.style)startDivRef.current.style.display  = 'none'
      if(loopVideoRef.current)loopVideoRef.current.enabled = false
      if(loopVideoRef.current)loopVideoRef.current.style.zIndex = 3
      if(loopVideoRef.current)loopVideoRef.current.play()
    },14900)
  }
  function closeNav(){
    setIsNavOpen(false)
  }
  const topRef= useRef(null)
  useLayoutEffect(()=>{
      setTimeout(()=>{
        if(topRef?.current)
         topRef.current.scrollIntoView();
      },500)
  },[])
  return (
    <div className="flex flex-col w-full items-center">
        <div ref={topRef}/>
        <div className='relative' style={{visibility : videoLoaded ? 'visible' : 'hidden'}}>
          <div onClick={() => setIsNavOpen(true)} className='w-[9%] h-[3%] top-[10%] left-[84%] absolute flex flex-col items-center justify-between' style={{zIndex:99}}>
            <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
            <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
            <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
          </div>
          <Nav closeNav={closeNav} isNavOpen={isNavOpen} />
          <div ref={startDivRef} style={{zIndex:2}} className='absolute h-full flex flex-row items-center justify-center'>
            <video ref={startVidRef} src='/startmp4.mp4' muted onPlay={VideoReady} controls={false} autoPlay={true} playsInline  style={{width:"100vw"}}/>        
          </div>
          <div style={{zIndex:1}} className='h-full flex flex-row items-center justify-center'>
            <video ref={loopVideoRef} loop src='/loop.mp4' muted controls={false} playsInline  style={{width:"100vw"}}/>                
          </div>
          {isClick && <div className='absolute w-full h-[25%] top-[55%] flex flex-col items-center justify-between' style={{zIndex:97}}>
            <button className='w-[74%] h-[45%]' onClick={() => navigate('/verify')} style={{zIndex:99}}></button>
            <div className='w-[74%] h-[45%]' style={{zIndex:99}} onClick={()=>{
                  insertRedirectRecords('https://www.bochk.com/s/a/sogocard_360')
                  window.open(`https://www.bochk.com/s/a/sogocard_360`, '_blank');
                }}
            />
          </div>}
        </div>
        {!videoLoaded && <div className='absolute w-full h-full flex items-center justify-center'>
          <LoadingSvg  width={'20%'}/>
        </div>}
    </div>
  );
}

export default App;